import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../lib/api';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [firma, setFirma] = useState(null);
  const [loading, setLoading] = useState(true);
  const [needsRegistration, setNeedsRegistration] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const status = await api.get('/auth/setup-status');
      setNeedsRegistration(status.data.needs_registration);
      if (localStorage.getItem('token')) {
        const me = await api.get('/auth/me');
        setUser(me.data.user);
        // Sync tema fra firma (kun ved auth-init, ikke ved navigering)
        try {
          const f = await api.get('/firma');
          if (f.data) setFirma(f.data);
          if (f.data?.tema) {
            localStorage.setItem('tema', f.data.tema);
            document.documentElement.setAttribute('data-template', f.data.tema);
            window.dispatchEvent(new Event('tema-endret'));
          }
        } catch {}
      } else {
        setUser(null);
        setFirma(null);
      }
    } catch {
      setUser(null);
      localStorage.removeItem('token');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (epost, passord, totp) => {
    const r = await api.post('/auth/login', { epost, passord, totp });
    localStorage.setItem('token', r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (firma_navn, navn, epost, passord, er_forening = false) => {
    const r = await api.post('/auth/register', { firma_navn, navn, epost, passord, er_forening });
    localStorage.setItem('token', r.data.token);
    setUser(r.data.user);
    setNeedsRegistration(false);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    setFirma(null);
  };

  return (
    <AuthContext.Provider value={{ user, firma, setFirma, loading, needsRegistration, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};
